<template>
<div class="page_hotel">
  <div class="container py-5">
    <div class="page_topic_blcok my-4">
      <div class="topic_border">
        <p class="topic_eng">HOTEL BOOKING</p>
        <p class="topic_cht">特約飯店</p>
      </div>
    </div>
    <!--合作單位-->    

  </div> 
</div>



</template>

<script>
export default {
  data () {
    return{};
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/hotel.vue